import { css } from '@emotion/react'
import { useState } from 'react'
import { inject, observer } from 'mobx-react'
import _ from 'lodash'

import { ButtonsBox, Button, CurrencyText, Drawer } from '../../../../components'
import { withRouterProps } from '../../../../utils'
import { trackInvestmentsByTaxType } from '../../utils'
import { TotalBalanceBox, GreyText, LightGreyText } from '../../styled'
import EditInvestment from '../EditInvestment'
import AddInvestmentButton from './AddInvestmentButton'
import InvestmentGroup from './InvestmentGroup'

const InvestmentsDisplay = props => {
  const { type, accountType, id } = props.match.params
  const {
    plaidLinkedAccountIds,
    features: { editInstitutionalAccount },
  } = props.store
  const {
    account: { rothContribAllowed, posttaxContribAllowed },
    investments,
    investedInvestments,
    totalBalance,
    preTaxInvestments,
    rothInvestments,
    afterTaxInvestments,
    notInvestedInvestments,
    preTaxBalance,
    rothBalance,
    afterTaxBalance,
  } = props.account
  const canEdit = type !== 'institutional' || editInstitutionalAccount
  const isWizard = props.location.pathname.substring(0, 14) === '/accounts/add/'
  const plaidAccountLinked = _.includes(plaidLinkedAccountIds, Number(id))
  const showSplitBalanceWarning =
    isWizard && plaidAccountLinked && (rothContribAllowed || posttaxContribAllowed)
  const [editInvestment, setEditInvestment] = useState(null)

  const toggleEdit = (id, event) => {
    event?.stopPropagation()
    setEditInvestment(id)
  }

  const handleUpdateBalances = () => {
    const { navigate, match } = props
    const { type, accountType, id } = match.params
    navigate(`/accounts/${type}/${accountType}/${id}/update-balances`)
  }

  return (
    <div>
      {canEdit && !isWizard && (
        <ButtonsBox
          css={css`
            flex-direction: row-reverse;
            margin: 0;
          `}>
          <Button
            label='Update balances only'
            onClick={handleUpdateBalances}
            primary
            width='215px'
          />
        </ButtonsBox>
      )}
      {canEdit && !isWizard && investments.length > 5 && (
        <div
          css={css`
            margin: 20px 0;
          `}>
          <AddInvestmentButton
            linkAddress={`/accounts/add/${type}/${accountType}/${id}/investment`}
          />
        </div>
      )}
      {investedInvestments.length > 0 && (
        <div
          css={css`
            margin-bottom: 40px;
          `}>
          <TotalBalanceBox>
            <LightGreyText>Account balance: </LightGreyText>
            <GreyText>
              <CurrencyText decimalScale={2} value={totalBalance} />
            </GreyText>
          </TotalBalanceBox>
        </div>
      )}
      {trackInvestmentsByTaxType(accountType) ? (
        <div>
          {preTaxInvestments.length > 0 && (
            <div
              css={css`
                margin-bottom: 40px;
              `}>
              <InvestmentGroup
                balance={preTaxBalance}
                balanceLabel='Pre-tax balance:'
                investments={preTaxInvestments}
                title='Pre-tax investments'
                accountId={id}
                canEdit={canEdit}
                toggleEdit={toggleEdit}
                showSplitBalanceWarning={showSplitBalanceWarning}
              />
            </div>
          )}

          {rothInvestments.length > 0 && (
            <div
              css={css`
                margin-bottom: 40px;
              `}>
              <InvestmentGroup
                balance={rothBalance}
                balanceLabel='Roth balance:'
                investments={rothInvestments}
                title='Roth investments'
                accountId={id}
                canEdit={canEdit}
                toggleEdit={toggleEdit}
              />
            </div>
          )}

          {afterTaxInvestments.length > 0 && (
            <div
              css={css`
                margin-bottom: 40px;
              `}>
              <InvestmentGroup
                balance={afterTaxBalance}
                balanceLabel='After-tax balance:'
                investments={afterTaxInvestments}
                title='After-tax investments'
                accountId={id}
                canEdit={canEdit}
                toggleEdit={toggleEdit}
              />
            </div>
          )}
        </div>
      ) : (
        investedInvestments.length > 0 && (
          <div
            css={css`
              margin-bottom: 40px;
            `}>
            <InvestmentGroup
              investments={investedInvestments}
              balance={totalBalance}
              accountId={id}
              canEdit={canEdit}
              toggleEdit={toggleEdit}
            />
          </div>
        )
      )}
      {notInvestedInvestments.length > 0 && trackInvestmentsByTaxType(accountType) && (
        <div
          css={css`
            margin-bottom: '40px';
          `}>
          <InvestmentGroup
            accountId={id}
            hideBalance
            investments={notInvestedInvestments}
            title='Other available investment options'
          />
        </div>
      )}

      {canEdit && (
        <AddInvestmentButton
          linkAddress={`/accounts/add/${type}/${accountType}/${id}/investment`}
        />
      )}
      <Drawer active={editInvestment} title='Edit investment' maxWidth='700px' width='60%'>
        {editInvestment && <EditInvestment investmentId={editInvestment} toggleEdit={toggleEdit} />}
      </Drawer>
    </div>
  )
}

export default withRouterProps(inject('store', 'account')(observer(InvestmentsDisplay)))
